/* FZK Cart Rules engine v5 - reads window.FZK_RULES.
   Instant: bundles the gift into the SAME /cart/add request (fetch OR xhr; JSON OR FormData).
   De-dupes against the LIVE cart (gift added once); re-adds when the trigger is added again.
   Auto-clears the gift when no trigger remains; gift stays removable. No sessionStorage. */
(function () {
  'use strict';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var RULES = (window.FZK_RULES || []).filter(function (r) { return r && r.enabled; });
  if (!RULES.length) return;
  var PROP = '_fzk_rule';
  var cart = {};
  var cleaning = false;

  function num(v) { return typeof v === 'string' ? parseInt(v, 10) : v; }
  function has(vid) { return !!cart[num(vid)]; }
  function track(ev, d) { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev }, d)); }
  function isAddUrl(u) { return /\/cart\/add(\.js)?(\?|$)/.test(u || ''); }
  function isCartUrl(u) { return /\/cart(\/|\.js|\?|$)/.test(u || ''); }

  function setFullCart(items) {
    var nv = {};
    (items || []).forEach(function (it) { var v = it.variant_id || it.id; if (v) nv[num(v)] = true; });
    cart = nv;
  }
  function addToCart(items) {
    (items || []).forEach(function (it) { var v = it.variant_id || it.id; if (v) cart[num(v)] = true; });
  }
  function triggerPresent(items, rule) {
    var w = rule.when || {};
    return (items || []).some(function (it) {
      if (w.variantIds && w.variantIds.indexOf(it.variant_id) > -1) {
        if (w.sellingPlanIds) { var al = it.selling_plan_allocation; var sp = al && al.selling_plan && al.selling_plan.id; return w.sellingPlanIds.indexOf(sp) > -1; }
        return true;
      }
      return false;
    });
  }
  function refresh() {
    if (window.liquidAjaxCart && window.liquidAjaxCart.get) window.liquidAjaxCart.get();
    else if (window.KozlerCartDrawer && window.KozlerCartDrawer.openAndRefresh) window.KozlerCartDrawer.openAndRefresh();
  }
  function removeKeys(keys) {
    cleaning = true;
    keys.forEach(function (k) {
      if (window.liquidAjaxCart && window.liquidAjaxCart.change) window.liquidAjaxCart.change({ id: k, quantity: 0 });
      else fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: k, quantity: 0 }) }).then(refresh);
      track('fzk_auto_remove', { line: k });
    });
    setTimeout(function () { cleaning = false; }, 400);
  }
  function cleanupOrphans(items) {
    if (cleaning) return;
    var keys = [];
    RULES.forEach(function (rule) {
      if (triggerPresent(items, rule)) return;
      (items || []).forEach(function (it) {
        if (it.properties && it.properties[PROP] === rule.id && it.key) keys.push(it.key);
      });
    });
    if (keys.length) removeKeys(keys);
  }
  function noteResponse(url, json) {
    if (!json || typeof json !== 'object') return;
    if (isAddUrl(url)) {
      var added = json.items || (json.id != null ? [json] : null);
      if (added) addToCart(added);
    } else if (json.items) {
      setFullCart(json.items);
      cleanupOrphans(json.items);
    }
  }

  function giftItem(rule, a) {
    var it = { id: a.variantId, quantity: a.quantity || 1, properties: {} };
    it.properties[PROP] = rule.id;
    if (a.free) it.properties._fzk_gift = 'true';
    if (a.sellingPlan) it.selling_plan = a.sellingPlan;
    return it;
  }
  function giftsForAdd(items) {
    var out = [];
    RULES.forEach(function (rule) {
      var w = rule.when || {};
      var hit = items.some(function (it) {
        var vid = num(it.id);
        if (w.variantIds && w.variantIds.indexOf(vid) > -1) {
          if (w.sellingPlanIds) return w.sellingPlanIds.indexOf(num(it.selling_plan)) > -1;
          return true;
        }
        return false;
      });
      if (!hit) return;
      (rule.add || []).forEach(function (a) {
        if (has(a.variantId)) return;
        var dupe = items.some(function (it) { return num(it.id) === a.variantId; })
                || out.some(function (it) { return it.id === a.variantId; });
        if (dupe) return;
        out.push(giftItem(rule, a));
        cart[a.variantId] = true;
        track('fzk_auto_add', { rule: rule.id, variant: a.variantId, free: !!a.free });
      });
    });
    return out;
  }

  function parseBody(body) {
    if (typeof body === 'string' && body.charAt(0) === '{') {
      var data = JSON.parse(body);
      var items;
      if (data.items) items = data.items;
      else if (data.id != null) {
        var one = { id: data.id, quantity: data.quantity || 1 };
        if (data.properties) one.properties = data.properties;
        if (data.selling_plan) one.selling_plan = data.selling_plan;
        items = [one];
      } else return null;
      var extra = {};
      if (data.sections != null) extra.sections = data.sections;
      if (data.sections_url != null) extra.sections_url = data.sections_url;
      return { items: items, extra: extra, format: 'json' };
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var obj = {};
      body.forEach(function (v, k) { obj[k] = v; });
      var arr = [];
      if (obj.id != null) {
        var it = { id: parseInt(obj.id, 10), quantity: obj.quantity ? parseInt(obj.quantity, 10) : 1 };
        if (obj.selling_plan) it.selling_plan = obj.selling_plan;
        var props = {};
        for (var key in obj) {
          var m = key.match(/^properties\[(.+)\]$/);
          if (m) props[m[1]] = obj[key];
        }
        if (Object.keys(props).length) it.properties = props;
        arr = [it];
      } else {
        var byIdx = {};
        for (var key2 in obj) {
          var m2 = key2.match(/^items\[(\d+)\]\[([^\]]+)\]$/);
          if (m2) { byIdx[m2[1]] = byIdx[m2[1]] || {}; byIdx[m2[1]][m2[2]] = obj[key2]; }
        }
        for (var i in byIdx) {
          var s = byIdx[i];
          var it2 = { id: parseInt(s.id, 10), quantity: s.quantity ? parseInt(s.quantity, 10) : 1 };
          if (s.selling_plan) it2.selling_plan = s.selling_plan;
          arr.push(it2);
        }
      }
      if (!arr.length) return null;
      var extra2 = {};
      if (obj.sections != null) extra2.sections = obj.sections;
      if (obj.sections_url != null) extra2.sections_url = obj.sections_url;
      return { items: arr, extra: extra2, format: 'formdata' };
    }
    return null;
  }
  function buildBody(items, extra, format) {
    if (format === 'json') {
      var data = { items: items };
      if (extra.sections != null) data.sections = extra.sections;
      if (extra.sections_url != null) data.sections_url = extra.sections_url;
      return JSON.stringify(data);
    }
    var fd = new FormData();
    items.forEach(function (it, i) {
      fd.append('items[' + i + '][id]', it.id);
      fd.append('items[' + i + '][quantity]', it.quantity || 1);
      if (it.selling_plan) fd.append('items[' + i + '][selling_plan]', it.selling_plan);
      if (it.properties) {
        for (var pk in it.properties) fd.append('items[' + i + '][properties][' + pk + ']', it.properties[pk]);
      }
    });
    if (extra.sections != null) fd.append('sections', extra.sections);
    if (extra.sections_url != null) fd.append('sections_url', extra.sections_url);
    return fd;
  }
  function augment(body) {
    var parsed = parseBody(body);
    if (!parsed) return null;
    var gifts = giftsForAdd(parsed.items);
    if (!gifts.length) return null;
    return buildBody(parsed.items.concat(gifts), parsed.extra, parsed.format);
  }

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = (init && init.method) || (input && input.method) || 'GET';
        if (isAddUrl(url) && String(method).toUpperCase() === 'POST' && init && init.body != null) {
          var nb = augment(init.body);
          if (nb != null) init = Object.assign({}, init, { body: nb });
        }
      } catch (e) {}
      var p = origFetch.call(this, input, init);
      try {
        if (isCartUrl(url)) p.then(function (res) {
          try { res.clone().json().then(function (j) { noteResponse(url, j); }).catch(function () {}); } catch (e) {}
        });
      } catch (e) {}
      return p;
    };
  }

  if (window.XMLHttpRequest) {
    var XP = window.XMLHttpRequest.prototype;
    var oOpen = XP.open, oSend = XP.send;
    XP.open = function (method, url) {
      try { this._fzkUrl = url; this._fzkAdd = String(method || '').toUpperCase() === 'POST' && isAddUrl(url); } catch (e) {}
      return oOpen.apply(this, arguments);
    };
    XP.send = function (body) {
      try {
        if (this._fzkAdd && body != null) { var nb = augment(body); if (nb != null) body = nb; }
        if (this._fzkUrl && isCartUrl(this._fzkUrl)) {
          var xhr = this;
          xhr.addEventListener('load', function () {
            try { noteResponse(xhr._fzkUrl, JSON.parse(xhr.responseText)); } catch (e) {}
          });
        }
      } catch (e) {}
      return oSend.call(this, body);
    };
  }

  function seed() {
    var el = document.querySelector('[data-ajax-cart-initial-state]');
    if (el) { try { var c = JSON.parse(el.textContent); if (c && c.items) { setFullCart(c.items); return; } } catch (e) {} }
    try { fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }); } catch (e) {}
  }
  seed();
})();
